<script lang="ts">
  import { Icon } from '@shared/ui/icon';
  import { cn } from '@shared/utils';

  export let classes = '';
</script>

<a
  class="{cn(
    'flex w-max items-center gap-1.5 rounded-[4px] border border-emerald-600/25 bg-emerald-600/10 px-2 py-1.5 font-medium text-emerald-600',
    classes,
  )}"
  href="https://github.com/digital-original/contracts/blob/master/audit/audit.pdf"
  target="_blank"
  rel="noopener noreferrer"
  title="Smart Contract audited by Blaize Tech"
>
  <Icon name="protection" />

  Smart Contract audited by Blaize Tech
</a>
